import { render, staticRenderFns } from "./DetailProjectActivitiesProduct.vue?vue&type=template&id=2d8de2e2"
import script from "./DetailProjectActivitiesProduct.vue?vue&type=script&lang=js"
export * from "./DetailProjectActivitiesProduct.vue?vue&type=script&lang=js"
import style0 from "./DetailProjectActivitiesProduct.vue?vue&type=style&index=0&id=2d8de2e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports